// this mode extends the build-in linestring tool, displaying the current length
// of the line as the user draws using a point feature and a symbol layer
import MapboxDraw, { DrawCustomMode } from "@mapbox/mapbox-gl-draw";

import { createMeasurementVertex, displayStartEndVertexes } from "./utils";

const ExtendedLineStringMode: DrawCustomMode<
    {
        currentVertexPosition: number;
        line: GeoJSON.LineString & {
            id: string;
            addCoordinate: () => void;
            removeCoordinate: (path?: number) => void;
        };
        direction: string;
    },
    unknown
> = {
    ...MapboxDraw.modes.draw_line_string,

    toDisplayFeatures: function (state, geojson, display) {
        const originalToDisplayFeatures = MapboxDraw.modes.draw_line_string.toDisplayFeatures;
        originalToDisplayFeatures.call(this, state, geojson, display);

        displayStartEndVertexes(geojson, display);

        if (
            geojson.type !== "Feature" ||
            geojson.geometry.type !== "LineString" ||
            geojson.properties?.id !== state.line.id ||
            geojson.geometry.coordinates.length < 2 ||
            !state.line.id
        )
            return;
        display(
            createMeasurementVertex(
                geojson,
                state.line.id,
                geojson.geometry.coordinates[geojson.geometry.coordinates.length - 1],
            ),
        );
    },

    onKeyUp(state, e) {
        if (e.keyCode === 68) {
            state.currentVertexPosition--;
            state.line.removeCoordinate(state.line.coordinates.length - 2);
        } else {
            const originalOnKeyUp = MapboxDraw.modes.draw_line_string.onKeyUp;
            originalOnKeyUp?.call(this, state, e);
        }
    },
};

export default ExtendedLineStringMode;
